module.exports = __webpack_public_path__ + "img/38.9.TU.6cef9c81.png";